import { dropdownTriggerClassname } from "app/components/Dropdown";
import TicketTypeIcon from "app/components/TicketTypeIcon";
import CustomTooltip from "app/components/Tooltip";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { getTicketTypeByIds } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/helper";
import { ITicketTypes } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import { selectTicketTypes } from "app/redux/selector";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

interface CustomProps {
  value: string;
  onUpdate: (id: string) => void;
}

const TicketTypeSelection: React.FC<CustomProps> = ({ value, onUpdate }) => {
  const ticketTypes = useSelector(selectTicketTypes);
  const updateValue = (data: ITicketTypes) => {
    // update form out side parent component
    onUpdate(data._id);
  };

  const ticketType = useMemo(() => {
    return getTicketTypeByIds(ticketTypes, value)[0];
  }, [ticketTypes, value]);

  return (
    <React.Fragment>
      <CommonTicketTypeSelection
        trigger={
          <button className={clsx("flex items-center hover:border hover:border-gray-300 p-[4px] rounded-[2px] min-w-0 w-full cursor-pointer h-full overflow-hidden",dropdownTriggerClassname)}>
            <CustomTooltip
              text="Set ticket type"
              className="flex items-center min-w-0 w-full overflow-hidden"
              position="bottom"
            >
              <div className="flex items-center gap-2 min-w-0 w-full overflow-hidden">
                <TicketTypeIcon iconName={ticketType?.icon as string} />
                <span className="text-sm font-normal text-black truncate">
                  {ticketType?.name}
                </span>
              </div>
            </CustomTooltip>
          </button>
        }
        value={value}
        setValue={updateValue}
        showEndIcon
      />
    </React.Fragment>
  );
};

export default TicketTypeSelection;
